import httpClient from './httpClient';
import store from '@/store';

const baseEndPoint = '/v3/promotions';

const referral = code =>
  httpClient.post(`${baseEndPoint}/referral-code`, code, {
    auth: store.getters['register/userToken'],
  });

export default {
  referral,
};
